module.exports = __webpack_public_path__ + "img/AIDT-waw-logo.2a4935e5.jpg";